export let restRuntime = {
    token: {
        token_type: "",
        access_token: ""
    },
    useTestVersion: false,
    rootPath: "/"
}
